import { get } from 'svelte/store';
import { format } from 'svelte-i18n';

export const buildInputInterfaceData = (device, status) => {
	if (!device?.input_state) return [];

	const INPUT_COUNT = 2;
	const interfaceData = [];

	for (let index = 0; index < INPUT_COUNT; index++) {
		const state = status?.[`input:${index}`]?.state;

		if (typeof state !== 'boolean') continue;

		const label = get(format)('prop_input', {
			default: 'Input ({value})',
			values: { value: index },
		});

		const formattedState = state
			? get(format)('xt1_template_on', { default: 'On' })
			: get(format)('xt1_template_off', { default: 'Off' });

		interfaceData.push({
			name: `input_${index}`,
			icon: 'fa fa-plug',
			value: `${label}: ${formattedState}`,
		});
	}

	return interfaceData;
};
